<template>
    <div style="display: grid; place-items:center;width: 100%; height:100%">
        <main class="containerDetailMain">  
            <section class="containerDetailLeft">
                <div class="containerProps">
                    <button v-on:click="goBack()"> <img src="@/assets/left-curved-arrow-svgrepo-com.svg" height="32px" width="32px"></button>
                    <h2><strong>SERIAL NUMBER:</strong> {{ this.cont.serialNumber }}</h2>
                    <h2><strong>CAPACITY: </strong>{{ this.cont.capacity }} / {{ this.cont.totalCapacity }}</h2>
                    <h2><strong>TEMPERATURE: </strong> {{ this.cont.temperature }}ºC</h2>
                    
                </div>
                <div class="containerGbgCls">
                    <p>
                        <span class="garbClsSpan"><strong>GARBAGE CLASS:</strong> </span>
                        <img v-if="cont.garbageClass == 'organic'" src="@/assets/scenarios/garbage/container/organic.png" width="20px" height="20px">
                        <img v-if="cont.garbageClass == 'plastic'" src="@/assets/scenarios/garbage/container/plastic.png" width="20px" height="20px">
                        <img v-if="cont.garbageClass == 'paper'" src="@/assets/scenarios/garbage/container/paper.png" width="20px" height="20px">
                    </p>
                </div>
                
            </section>
            <section class="containerDetailRight">
                <div id="map">
                    <l-map :zoom="zoom" :center="center">
                        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                        <l-marker :lat-lng="center"></l-marker>
                        
                    </l-map>
                </div>
                <div class="mapWrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%"> <polygon points="0,100 10,100 0,0" style="fill:#25262D;" /> </svg>
                </div>
                
            </section>
        </main>
    </div>
    
</template>
<script>
import {LMap, LTileLayer, LPolyline} from 'vue2-leaflet';
import containersGarbageIIOTAPI from '@/services/containersGarbageIIOTAPI';
export default {
    name: 'ContainerDetailView',
    components: {
        LMap,
        LTileLayer,
        LPolyline
    },
    data () {
        return {
            cont: {},
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 8,
            center: [36.83, -2.388],
        }
    },
    methods: {
        goBack () {
            this.$router.push({ path: "/scenarios/iiot/containers"});
        },
    },
    async mounted() {
        containersGarbageIIOTAPI.get('/' + this.$route.params.serialNumber + '/property/containerDetails').then((res) => {
            this.cont = res.data;
            console.log(this.cont);
            this.center = [parseFloat(this.cont.location.lat), parseFloat(this.cont.location.lng)];
            this.zoom = 15;
        });
        
    },
}
</script>
<style>
.containerDetailMain {
    margin: 1rem;
    width: 65%;
    height: 66vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-items: center;
    color: white;
    min-height: 100px;
    
}

.containerDetailLeft {
    display: grid;
    width: 100%;
    height: 100%;
    padding: 10px;
    vertical-align: middle;
    background-color: #25262D;
}

.containerDetailRight {
    display: grid;
    position: relative;
    place-items: center;
    width: 100%;
    height: 100%;
    
    vertical-align: middle;
    background-color: #f6f6f6;
}

.containerProps {
    margin: 0 1rem;
}

.containerGbgCls {
    margin: 0 1rem;
    margin-top: 1rem;
    position: absolute;
    bottom: 0;
}

#map {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: all;
    z-index: 0;
}

.mapWrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 23, 0);
    pointer-events: none;
}
</style>